//#region ng
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
//#endregion

//#region mat
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
// import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
//#endregion

//#region modules
import { CorPipesModule } from '../../_shared/_core/_ng/_pipes/cor-pipes.module';
// import { CorMatComponentsModule } from '../../_components/_mat/cor-mat-components.module';
import { CorDirectivesModule } from '../../_shared/_core/_ng/_directives/cor-directives.module';
//#endregion

//#region components
import { HorarioFormModal } from '..';
//#endregion

@NgModule({
  imports: [
    // CorMatComponentsModule,
    CorDirectivesModule,
    CorPipesModule,
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatToolbarModule,
    // MatSlideToggleModule,
    ReactiveFormsModule,
  ],
  declarations: [
    HorarioFormModal,
  ],
  exports: [
    HorarioFormModal,
  ],
})
export class HorarioFormModalModule { }
